@if(message()){
<div class="messages-container">
  <div class="message" [ngClass]="message()?.severity">
    {{ message()?.text }}
    <img class="close" src="assets/close.svg" (click)="onClose()">
  </div>
</div>
}